
import React from 'react';
import { Tabs, TabsContent, TabsList, TabsTrigger } from '@/components/ui/tabs';

interface DeviceRegistrationTabsProps {
  activeTab: string;
  setActiveTab: (value: string) => void;
  registerContent: React.ReactNode;
  manageContent: React.ReactNode;
}

const DeviceRegistrationTabs: React.FC<DeviceRegistrationTabsProps> = ({ 
  activeTab, 
  setActiveTab, 
  registerContent, 
  manageContent 
}) => {
  return (
    <Tabs value={activeTab} onValueChange={setActiveTab} defaultValue="manage">
      <TabsList className="grid w-full md:w-auto grid-cols-2">
        <TabsTrigger value="register">Register Device</TabsTrigger>
        <TabsTrigger value="manage">Manage Devices</TabsTrigger>
      </TabsList>
      
      <TabsContent value="register" className="space-y-4 mt-6">
        {registerContent}
      </TabsContent>
      
      <TabsContent value="manage" className="space-y-4 mt-6">
        {manageContent}
      </TabsContent>
    </Tabs>
  );
};

export default DeviceRegistrationTabs;
